import React from 'react';
import PropTypes from 'prop-types';
import './LeftNavigationModule.scss';

/**
 * @group Layout
 * Displays left navigation component
 */

const LeftNavigationModule = (props) => {
  const { opts = {}, channel } = props;
  const {
    ctaLink,
    heading,
    links
  } = opts;
  if (channel === 'mobile') {
    return null;
  }
  return (
    <div id="leftNavigationModule">
      <ul className="list list--type-plain u__text-align--left">
        <li className="List__item list__item--padding-none">
          <b><a href={ctaLink}>{heading}</a></b>
        </li>
        {(links || []).map((navLink) => {
          return (
            <li className="List__item list__item--padding-none" key={navLink.id}>
              <a href={navLink.link}>{navLink.linkText}</a>
            </li>
          );
        })}
      </ul>
    </div>

  );
};

LeftNavigationModule.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    heading: PropTypes.string,
    ctaLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    links: PropTypes.arrayOf(PropTypes.shape({
      linkText: PropTypes.string,
      link: PropTypes.string

    }))
  }).isRequired,
  channel: PropTypes.string
};
LeftNavigationModule.defaultProps = {
  channel: 'desktop'
};

export default LeftNavigationModule;
